import { Component, input, output } from '@angular/core';
import { ai as AiGen } from '@valvur/shared-grpc';
import {
  getCategoryIcon,
  getSeverityColor,
} from '../../constants/topic-category.constants';

@Component({
  selector: 'app-parent-ai-active-topic-bar',
  standalone: true,
  templateUrl: './parent-ai-active-topic-bar.component.html',
  styleUrl: './parent-ai-active-topic-bar.component.scss',
})
export class ParentAiActiveTopicBarComponent {
  topic = input.required<AiGen.TopicThreadDto>();

  clear = output<void>();

  protected getCategoryIcon = getCategoryIcon;
  protected getSeverityColor = getSeverityColor;
}
